<template>
  <v-carousel
    class="carousel dashboard-carousel"
    interval="4185"
    height="auto"
    :hide-delimiters="items.length === 1"
    :show-arrows="items.length > 1"
    :cycle="items.length > 1"
    hide-delimiter-background
    show-arrows-on-hover
    cycle
    light
  >
    <v-carousel-item
      v-for="item in items"
      :key="item.id"
      :src="item.banner_url"
      :class="{clickable: item.link && !item.show_link_button}"
      @click="item.link && !item.show_link_button ? goToLink(item.link, item.target) : null"
      reverse-transition="fade-transition"
      transition="fade-transition"
      class="carousel__item"
    >
      <div class="carousel__content" v-if="item.link && item.show_link_button">
        <v-btn
          class="carousel__content-btn"
          v-if="IsRemoteUrl(item.link)"
          :href="item.link"
          :target="item.target"
        >Подробнее</v-btn>
        <v-btn
          class="carousel__content-btn"
          v-else
          :to="item.link"
          :target="item.target"
        >Подробнее</v-btn>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
  export default {
    props: ['items'],
    methods: {
      IsRemoteUrl(url) {
        return (url.indexOf('://') !== -1);
      },
      goToLink(link, target) {
        window.open(link, target);
      },
    },
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables';

  .carousel {
    //background: #e5f6fb;

    .v-image__image--cover {
      background-size: cover;

      @media all and (min-width: 1260px){
        background-size: cover;
      }
    }

    .v-icon.v-icon {
      color: white!important;
    }

    &__content {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: flex-end;
      padding-bottom: 60px;
    }
  }

  .dashboard-carousel {
    height: 288px!important;

    @media all and (max-width: 1259px) {
      height: 215px!important;
    }
    @media all and (max-width: 959px) {
      height: 24vw!important;
    }
    @media all and (max-width: 599px) {
      height: 23vw!important;

      .carousel__content {
        display: none;
      }
    }

    .v-item-group {
      //background-color: rgba(0,0,0,0.2);
      //border-radius: 10px;

      .v-btn:before {
        //display: none;
        border-radius: 50%;
      }

      .mdi-circle {
        font-size: 12px!important;
      }

      .v-btn--icon.v-size--small {
        width: auto!important;
        height: auto!important;
      }
    }
  }
</style>
